import {
  SiAmazoncloudwatch,
  SiAmazonwebservices,
  SiAwsamplify,
  SiAwslambda,
  SiCss3,
  SiCypress,
  SiDocker,
  SiExpress,
  SiFastify,
  SiFirebase,
  SiGit,
  SiGithub,
  SiGraphql,
  SiHtml5,
  SiJavascript,
  SiJest,
  SiMongodb,
  SiNextdotjs,
  SiNodedotjs,
  SiOracle,
  SiPostgresql,
  SiProxmox,
  SiReact,
  SiRedux,
  SiStyledcomponents,
  SiTailwindcss,
  SiTypescript,
} from "react-icons/si";
import React from "react";
import { CSSColor } from "@frontend/app/constants/colors.ts";
import clsx from "clsx";

type Skill = {
  name: string;
  Logo: React.ElementType;
  color: CSSColor;
  subSkills?: string[];
};

const SKILLS: readonly Skill[] = Object.freeze([
  {
    name: "React",
    Logo: SiReact,
    color: "#61DAFB" as CSSColor,
  },
  {
    name: "Next.js",
    Logo: SiNextdotjs,
    color: "#FFFFFF" as CSSColor,
  },
  {
    name: "TypeScript",
    Logo: SiTypescript,
    color: "#3178C6" as CSSColor,
  },
  {
    name: "JavaScript",
    Logo: SiJavascript,
    color: "#F7DF1E" as CSSColor,
  },
  {
    name: "HTML",
    Logo: SiHtml5,
    color: "#E34F26" as CSSColor,
  },
  {
    name: "CSS",
    Logo: SiCss3,
    color: "#1572B6" as CSSColor,
  },
  {
    name: "TailwindCSS",
    Logo: SiTailwindcss,
    color: "#38B2AC" as CSSColor,
  },
  {
    name: "Styled Components",
    Logo: SiStyledcomponents,
    color: "#DB7093" as CSSColor,
  },
  {
    name: "Node.js",
    Logo: SiNodedotjs,
    color: "#68A063" as CSSColor,
  },
  {
    name: "PostgreSQL",
    Logo: SiPostgresql,
    color: "#336791" as CSSColor,
    subSkills: ["PostGIS", "pgAdmin"],
  },
  {
    name: "Docker",
    Logo: SiDocker,
    color: "#2496ED" as CSSColor,
  },
  {
    name: "AWS",
    Logo: SiAmazonwebservices,
    color: "#FF9901" as CSSColor,
  },
  {
    name: "Amplify",
    Logo: SiAwsamplify,
    color: "#E7383C" as CSSColor,
  },
  {
    name: "CloudWatch",
    Logo: SiAmazoncloudwatch,
    color: "#D72B6C" as CSSColor,
  },
  {
    name: "Lambda",
    Logo: SiAwslambda,
    color: "#EC8109" as CSSColor,
  },

  {
    name: "Java",
    Logo: SiOracle,
    color: "#007396" as CSSColor,
  },
  {
    name: "Git",
    Logo: SiGit,
    color: "#F05032" as CSSColor,
  },
  {
    name: "Github",
    Logo: SiGithub,
    color: "#FFFFFF" as CSSColor,
  },
  {
    name: "Jest",
    Logo: SiJest,
    color: "#C21325" as CSSColor,
  },
  {
    name: "Cypress",
    Logo: SiCypress,
    color: "#5b80b1" as CSSColor,
  },
  {
    name: "Firebase",
    Logo: SiFirebase,
    color: "#FFCA28" as CSSColor,
  },
  {
    name: "Proxmox",
    Logo: SiProxmox,
    color: "#E57000" as CSSColor,
  },
  {
    name: "Redux",
    Logo: SiRedux,
    color: "#764ABC" as CSSColor,
  },
  {
    name: "MongoDB",
    Logo: SiMongodb,
    color: "#47A248" as CSSColor,
  },
  {
    name: "GraphQL",
    Logo: SiGraphql,
    color: "#E10098" as CSSColor,
  },
  {
    name: "Express",
    Logo: SiExpress,
    color: "#FFFFFF" as CSSColor,
  },
  {
    name: "Fastify",
    Logo: SiFastify,
    color: "#FFFFFF" as CSSColor,
  },
]);

const Skills = ({ className }: { className?: string }) => {
  return (
    <section className={clsx(className, "text-center")} id="skills">
      <h2 className="my-4 text-4xl">Languages & Frameworks</h2>
      <div className="flex flex-row flex-wrap gap-3 justify-center w-full max-w-full px-4 lg:w-2/3 lg:px-0 m-auto">
        {/*<FadeUp speed={10}>*/}
        {SKILLS.map((skill, i) => (
          <div
            key={i}
            className="flex items-center gap-2 p-4 glass rounded-lg shadow-md max-w-fit max-h-fit"
          >
            <skill.Logo size={48} color={skill.color} />
          </div>
        ))}
        {/*</FadeUp>*/}
      </div>
    </section>
  );
};

export default Skills;
